import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import GridView from 'components/GridView';
import VideoTile from 'components/VideoTile';
import ClassMode from 'enums/ClassMode';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMutedAction } from 'store/video/videoActions';
import VideoWrapper from '../../../components/videoWrapper';
import MeetingCaptions from '../video-components/MeetingCaptions';

const useStyles = makeStyles((theme) => ({
  layoutButtonsContainer: {
    position: 'absolute',
    top: '10px',
    left: '10px',
    zIndex: 100,
    borderRadius: '8px',
    backgroundColor: 'rgba(0,0,0,.5)',
    padding: '0 1em',
    lineHeight: 0,
    color: 'black',
  },
  toggleIcon: {
    cursor: 'pointer',
    color: 'white',
  },
  selectedIcon: {
    color: theme.palette.primary.main,
  },
}));

export default function ViewContainer() {
  const classes = useStyles();
  const { classMode, showCaptions, startAudio, audioVideo, contentTile } = useSelector(
    ({ user, video, chime }) => ({
      classMode: user.classMode,
      startAudio: video.startAudio,
      showCaptions: video.showCaptions,
      contentTile: video.contentTile,
      audioVideo: chime.audioVideo,
    })
  );
  const dispatch = useDispatch();
  const [layout, setLayout] = useState(classMode === ClassMode.Student);

  useEffect(() => {
    if (startAudio) {
      audioVideo.realtimeMuteLocalAudio();
      dispatch(setMutedAction(true));
    }
    const callback = (localMuted) => {
      dispatch(setMutedAction(localMuted));
    };
    if (audioVideo) {
      // @TODO: ADD CALLBACK
      audioVideo.realtimeSubscribeToMuteAndUnmuteLocalAudio(callback);
    }
    return () => {
      if (audioVideo) {
        audioVideo.stopLocalVideoTile();
        // @TODO: ADD CALLBACK
        audioVideo.realtimeUnsubscribeToMuteAndUnmuteLocalAudio(callback);
      }
    };
    // eslint-disable-next-line
  }, [startAudio]);

  const updateGuestSpeaker = () => {};

  const toggleGrid = () => {
    setLayout(false);
  };

  const toggleHostView = () => {
    setLayout(true);
  };

  const gridStyles = clsx({
    [classes.toggleIcon]: true,
    [classes.selectedIcon]: !layout,
  });

  const studentStyles = clsx({
    [classes.toggleIcon]: true,
    [classes.selectedIcon]: layout,
  });

  return (
    <>
      <div className={classes.layoutButtonsContainer}>
        <span onClick={toggleGrid} className={gridStyles}>
          <Typography>Meeting</Typography>
        </span>
        <span onClick={toggleHostView} className={studentStyles}>
          <Typography>Live Stream</Typography>
        </span>
      </div>

      {layout ? (
        <VideoWrapper />
      ) : (
        <GridView selectSpeaker={updateGuestSpeaker}>
          {contentTile?.id && (
            <VideoTile
              videoTileId={contentTile.tileId}
              thisAttendeeId={contentTile.id}
              isContent={true}
              height={'100%'}
            />
          )}
        </GridView>
      )}
      {showCaptions && <MeetingCaptions />}
    </>
  );
}
